import { createSlice } from '@reduxjs/toolkit';
import { fetchConstants } from '../../services/constantsAPI';

const constantsSlice = createSlice({
  name: 'constants',
  initialState: {
    data: null,
    initialized: false,
    loading: false,
    error: null
  },
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConstants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConstants.fulfilled, (state, action) => {
        let responseData = action.payload;
        if(responseData.taskStatuses) {
          responseData.taskStatuses = responseData.taskStatuses.filter(ts => ['UNAC', 'PLAN', 'PACK', 'GDET', 'HEAD', 'GHED', 'ARVD', 'GARR', 'RECY', 'GRCY', 'COMP', 'CLSD'].includes(ts.code))
        }
        if(responseData.resourceStatuses) {
          responseData.resourceStatuses = responseData.resourceStatuses.filter(ts => [ 'SDUE', 'PACK', 'BASE', 'HEAD', 'FREE', 'ARVD', 'OFFD', 'RECY', 'UVOR', 'BRK'].includes(ts.code))
        }
        if(!responseData.taskType) {
          responseData['taskType'] = [
            {id: "1", key: "RSS", code: "RSS"},
            {id: "2", key: "RCY", code: "Recovery"}
          ];
        }
        if(!responseData.faultType) {
          responseData['faultType'] = [
            {
                "id": "75",
                "key": "FB",
                "code": "FLAT BATTERY"
            },
            {
                "id": "121",
                "key": "LOP",
                "code": "LOSS OF POWER"
            },
            {
                "id": "125",
                "key": "C/O",
                "code": "CUT OUT NON START"
            },
            {
                "id": "130",
                "key": "GBOX",
                "code": "GEARBOX"
            },
            {
                "id": "131",
                "key": "O/H",
                "code": "OVERHEATING"
            },
            {
                "id": "177",
                "key": "LOKC",
                "code": "KEYS LOCKED IN VEHICLE"
            },
            {
                "id": "218",
                "key": "DSH",
                "code": "WARNING LIGHT - ORANGE"
            },
            {
                "id": "252",
                "key": "CLTC",
                "code": "CLUTCH"
            },
            {
                "id": "440",
                "key": "BS26",
                "code": "OTHER."
            },
            {
                "id": "1682",
                "key": "1PAN",
                "code": "1 PUNCTURE - WITH A SPARE"
            },
            {
                "id": "1691",
                "key": "WSHC",
                "code": "WONT START"
            }
          ];
        }
        state.data = responseData
        state.loading = false;
        state.initialized = true;
      })
      .addCase(fetchConstants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  }
});

// export const { setBoundingBox } = constantsSlice.actions;
export default constantsSlice.reducer;
